import * as PIXI from "pixi.js";
import ButtonLayer from "../../layers/ButtonLayer";
import { EventBus, EnumEventBus } from "../../managers/EventBus";

import PayAmountBg from "./PayAmountBg";
import PlusButton from "../buttons/PlusButton";
import MinusButton from "../buttons/MinusButton";
import { BarBGBounds, ButtonBounds } from "../../types/Interface";

export default class PayAmount extends PIXI.Container {
  ButtonLayer = ButtonLayer.getInstance();
  EventBus = EventBus;
  Bounds: BarBGBounds;

  constructor(Bounds: BarBGBounds) {
    super();
    this.Bounds = Bounds;
    this.addBg();
    this.addPlusButton();
    this.addMinusButton();
    this.addToLayer();
  }

  addBg() {
    const bg = new PayAmountBg(this.Bounds)
    this.addChild(bg);
  }
  addPlusButton() {
    const newBounds: ButtonBounds = {
      x: this.Bounds.x + 60,
      y: this.Bounds.y + 16,
      width: 33,
      height: 33
    }

    const plus = new PlusButton(this, newBounds);
    this.addChild(plus);
  }
  addMinusButton() {
    const newBounds: ButtonBounds = {
      x: this.Bounds.x - 60,
      y: this.Bounds.y + 16,
      width: 33,
      height: 33
    }
    const minus = new MinusButton(this, newBounds);
    this.addChild(minus);
  }
  addToLayer() {
    this.ButtonLayer.addChild(this);
  }
}